import React from 'react';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import {lazy} from '@aboutyou/lazy-imports';

export const TrackAndTrace = lazy(
  () =>
    import('./TrackAndTrace.eager').then(mod => ({
      default: mod.TrackAndTrace,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
